import "./acl/acl.service";
import "./acl/acl.directive";
import "./auth/tokenInterceptor";
import "./auth/auth.service";
import "./auth/formatDeviceId.filter";
import "./auth/device.data-service";
import "./auth/request.data-service";
import "./autocomplete/service";
import "./category/service";
import "./config/config.provider";
import "./dates/locale-date.filter";
import "./dates/date.service";
import "./dates/online-date.service";
import "./dates/lastModification.filter";
import "./dates/relativeTime.filter";
import "./dates/slot.filter";
import "./export/service";
import "./gateway-api/gateway-api.service";
import "./images/rewrite-url-img.filter";
import "./io/io.service";
import "./item/service";
import "./live/live.service";
import "./locale.provider";
import "./locale-number/service";
import "./locale-number/currency.filter";
import "./online-item/service";
import "./logger/logger.decorator";
import "./logger/logger.service";
import "./logger/logger.run";
import "./map/map.component";
import "./media/service";
import "./mr-suricate/service";
import "./multiple-select/multiple-select.component";
import "./online-container/service";
import "./organization/service";
import "./contract/service";
import "./monext-contract/service";
import "./online-price/service";
import "./payment/service";
import "./link-payment/service";
import "./quotas/service";
import "./sale/service";
import "./search/service";
import "./sites/service";
import "./toaster/toaster.service";
import "./translations/service";
import "./upload/upload.service";
import "./img.directive";
import "./img-on-load.directive";
import "./img-placeholder.directive";
import "./mdBlur.directive";
import "./meta.service";
import "./on-long-touch.directive";
import "./promise.decorator";
import "./route-class.directive";
import "./slot/slot.component";
import "./theming.module";
import "./template.module";
import "./timing.service";
import "./thor-inview.directive";
import "./utils.service";
import "./maintenance/maintenance.run";
import { GTMService } from "./gtm.service";
import { WordpressService } from "./wordpress/wordpress.service";
import { IeUrlBuilderService } from "./ie-url-builder.service";
import { MapService } from "./map/map.service";
import { ImageService } from "./images/image.service";

angular.module("thor.core", [
    "thor.core.acl.service",
    "thor.core.acl.directive",
    "thor.core.auth.formatDeviceId.filter",
    "thor.core.auth.device-data-service",
    "thor.core.auth.request-data-service",
    "thor.core.auth.service",
    "thor.core.auth.tokenInterceptor",
    "thor.core.autocomplete.service",
    "thor.core.category.service",
    "thor.core.config.service",
    "thor.core.dates.locale-date.filter",
    "thor.core.dates.date.service",
    "thor.core.dates.online-date.service",
    "thor.core.dates.lastModification.filter",
    "thor.core.dates.relativeTime.filter",
    "thor.core.dates.slot.filter",
    "thor.core.export.service",
    "thor.core.gateway-api.service",
    "thor.core.images.rewriteUrlImg.filter",
    "thor.core.io",
    "thor.core.item.service",
    "thor.core.locale.provider",
    "thor.core.locale-number.service",
    "thor.core.locale-number.currency.filter",
    "thor.core.online-item.service",
    "thor.core.logger.decorator",
    "thor.core.logger.service",
    "thor.core.logger.run",
    "thor.core.map.component",
    "thor.core.media.service",
    "thor.core.multiple-select",
    "thor.core.online-container.service",
    "thor.core.organization.service",
    "thor.core.contract.service",
    "thor.core.monext-contract.service",
    "thor.core.live.service",
    "thor.core.mr-suricate.service",
    "thor.core.online-price.service",
    "thor.core.payment.service",
    "thor.core.link-payment.service",
    "thor.core.quotas.service",
    "thor.core.sale.service",
    "thor.core.search.service",
    "thor.core.sites.service",
    "thor.core.slot.component",
    "thor.core.timing.service",
    "thor.core.toaster.service",
    "thor.core.translations.service",
    "thor.core.upload.service",
    "thor.core.imgPlaceholder.directive",
    "thor.core.img.directive",
    "thor.core.img-on-load.directive",
    "thor.core.mdBlur.directive",
    "thor.core.meta",
    "thor.core.onLongTouch.directive",
    "thor.core.promise.decorator",
    "thor.core.routeClass.directive",
    "thor.theming",
    "thor.template",
    "thor.core.inview.directive",
    "thor.core.utils",
    "thor.core.maintenance.run"
])
    .service("ieUrlBuilderService", IeUrlBuilderService)
    .service("wordpressService", WordpressService)
    .service("mapService", MapService)
    .service("imageService", ImageService)
    .service("gtmService", GTMService);
